import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import parse from 'html-react-parser';

const GuideDetail = () => {
  const { uid } = useParams();
  const [guide, setGuide] = useState(null);
  const [codeExamples, setCodeExamples] = useState([]);

  useEffect(() => {
    axios
      .get(
        `http://localhost:1337/api/guides?filters[UID][$eq]=${uid}&populate=*`
      )
      .then((res) => {
        const guideData = res.data.data[0];
        setGuide(guideData);

        const guideId = guideData.id;
        return Promise.all([
          axios.get(
            `http://localhost:1337/api/code-examples?filters[guide][id][$eq]=${guideId}`
          ),
          axios.get(`http://localhost:1337/api/languages?populate=guides`),
        ]);
      })
      .then(([codeRes, langRes]) => {
        setCodeExamples(codeRes.data.data);
      })
      .catch((err) => console.error("Error:", err));
  }, [uid]);

  if (!guide) return <p>Loading...</p>;
  
  
  console.log("Content structure:", guide.content);

  
  const renderRichText = (content) => {
    
    if (typeof content === 'string') {
      return parse(content);
    }
    
    
    if (Array.isArray(content)) {
      return content.map((block, i) => {

        if (block.type === 'paragraph') {
          return <p key={i} className="my-2">{block.children.map((child, j) => {
            
            if (child.bold) {
              return <strong key={j}>{child.text}</strong>;
            }
            if (child.italic) {
              return <em key={j}>{child.text}</em>;
            }
            if (child.underline) {
              return <u key={j}>{child.text}</u>;
            }
            return <span key={j}>{child.text}</span>;
          })}</p>;
        }
        
        if (block.type === 'heading') {
          const HeadingTag = `h${block.level}`;
          return <HeadingTag key={i} className="font-bold my-3">{block.children.map((child, j) => 
            <span key={j}>{child.text}</span>
          )}</HeadingTag>;
        }
        
        if (block.type === 'list') {
          const ListTag = block.format === 'ordered' ? 'ol' : 'ul';
          return (
            <ListTag key={i} className="list-inside my-3">
              {block.children.map((item, k) => (
                <li key={k}>
                  {item.children.map((child, l) => (
                    <span key={l}>{child.text}</span>
                  ))}
                </li>
              ))}
            </ListTag>
          );
        }
        
        return <div key={i}>{JSON.stringify(block)}</div>;
      });
    }
    
    return <p>No content available</p>;
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold">{guide.title}</h1>

      <div className="mt-4 space-y-4">
        {renderRichText(guide.content)}
      </div>

      {codeExamples.length > 0 && (
        <div className="mt-10">
          <h2 className="text-2xl font-semibold mb-4">Try it Yourself</h2>
          {codeExamples.map((example) => (
            <TryItBlock key={example.id} code={example.code} />
          ))}
        </div>
      )}
    </div>
  );
};
const TryItBlock = ({ code }) => {
  const [userCode, setUserCode] = useState(code);
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = location.state || {};
  console.log(language);

  const runCode = () => {
    const encodedCode = encodeURIComponent(userCode);
    navigate(`/compiler?code=${encodedCode}&language=${language}`);
  };

  return (
    <div className="bg-gray-100 border p-4 rounded-lg mb-6">
      <textarea
        value={userCode}
        onChange={(e) => setUserCode(e.target.value)}
        rows={10}
        className="w-full p-2 font-mono text-sm border rounded"
      />
      <button
        onClick={runCode}
        className="mt-2 px-4 py-1 bg-blue-600 text-white rounded"
      >
        Run
      </button>
    </div>
  );
};

export default GuideDetail;
